import { orderStatus } from "../constants/commonConstants";

export const WRITER_TIP_WINDOW_DAYS_AFTER_COMPLETION = 30;

export const canTipWriter = (order) => {
  if (order?.status === orderStatus.ORDER_DELIVERED) {
    return true;
  }

  if (order?.status !== orderStatus.COMPLETED || !order?.completedDate) {
    return false;
  }

  const completedAt = new Date(order.completedDate).getTime();
  if (!Number.isFinite(completedAt)) {
    return false;
  }

  const tipWindowMs = WRITER_TIP_WINDOW_DAYS_AFTER_COMPLETION * 24 * 60 * 60 * 1000;
  return Date.now() - completedAt <= tipWindowMs;
};
